import { apiGet, apiPost } from '../client';
import type {
  CffDataSourceInfoResponseApi,
  ForecastResponseApi,
  ForecastRunResponseApi,
  ForecastRunStatusResponseApi,
} from '../models/forecast';
import type { ForecastRunTransactionResponseApi } from '../models/forecastRun';

export async function getForecast(
  period: string = '90d',
): Promise<ForecastResponseApi> {
  return apiGet<ForecastResponseApi>(
    `forecast?period=${encodeURIComponent(period)}`,
  );
}

interface ConsolidatedDataResponseApi {
  contributingSources: CffDataSourceInfoResponseApi[];
}

export async function getContributingSources(): Promise<
  CffDataSourceInfoResponseApi[]
> {
  const data = await apiGet<ConsolidatedDataResponseApi>('forecast/data');
  return data.contributingSources;
}

export async function getForecastRunTransactions(
  runId: number,
  fromDate?: string,
  toDate?: string,
): Promise<ForecastRunTransactionResponseApi[]> {
  const params = new URLSearchParams();
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  const qs = params.toString();
  return apiGet<ForecastRunTransactionResponseApi[]>(
    `forecast/runs/${runId}/transactions${qs ? `?${qs}` : ''}`,
  );
}

export async function getForecastRunStatus(): Promise<ForecastRunStatusResponseApi> {
  return apiGet<ForecastRunStatusResponseApi>('forecast/runs/current-status');
}

export async function getForecastRunHistory(
  limit: number = 20,
): Promise<ForecastRunResponseApi[]> {
  return apiGet<ForecastRunResponseApi[]>(`forecast/runs?limit=${limit}`);
}

export async function triggerForecastRun(): Promise<void> {
  await apiPost<unknown>('forecast/runs/trigger');
}
